import { createFeatureSelector,createSelector } from '@ngrx/store';
import {
DepartmentState,DEPARTMENT_FEATURE_KEY,selectAllDepartment,
selectDepartmentEntities,selectDepartmentFetched,
selectDepartmentLatestUpdatedAt
} from '../reducers/department.reducer';

const selectState = createFeatureSelector<DepartmentState>(DEPARTMENT_FEATURE_KEY);
export const getDepartmentDictionary = createSelector(selectState, selectDepartmentEntities);
export const getDepartmentLatestUpdatedAt = createSelector(selectState, selectDepartmentLatestUpdatedAt);
export const getDepartmentFetched = createSelector(selectState, selectDepartmentFetched);
export const getDepartments = createSelector(selectState, selectAllDepartment);
export const getDepartmentsActive = createSelector(getDepartments, (activities) => activities.filter(({DeletedAt}) => !DeletedAt));
export const getDepartmentById = (props: { id: number }) => createSelector(getDepartmentDictionary, (dictionary) => props.id && dictionary[props.id]);
